export default __webpack_public_path__ + "static/media/google-cloud-platform.0310f2b99a2bbed48912234bc9a9a4c2.svg";